import React from 'react';
// Inlined header to avoid module-resolution issues with Header component
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';
import Header from '../components/Header';

export default function FAQPage() {
  return (
    <div className="page-shell min-h-screen">
      <Header />

      <section className="relative mt-4 w-full overflow-hidden px-4 sm:px-6 lg:px-8">
        <div className="mx-auto w-full max-w-7xl rounded-[2rem] border border-[#dbe8f5] bg-white/85 px-6 py-10 shadow-[0_30px_80px_-52px_rgba(13,27,42,0.85)] backdrop-blur-sm sm:px-8 sm:py-12">
          <div className="pointer-events-none absolute -left-12 top-6 h-36 w-36 rounded-full bg-[#f2643f]/20 blur-3xl" />
          <div className="pointer-events-none absolute right-8 top-8 h-28 w-28 rounded-full bg-[#3182ce]/20 blur-3xl" />
          <div className="mx-auto max-w-4xl">
            <h1 className="mt-4 text-center text-4xl leading-tight text-[#102a43] sm:text-5xl">
              Frequently asked questions
            </h1>

            <p className="mx-auto mt-3 max-w-2xl text-center text-sm leading-7 text-[#4c5f75] sm:text-base">
              Everything you need to understand your subscription management, cancellation process, and support access.
            </p>
          </div>
        </div>
      </section>

      <main className="mt-2 px-4 py-8 sm:px-6 lg:mt-3 lg:px-8 lg:py-10">
        <div className="mx-auto max-w-5xl px-2 sm:px-0">
          <section>
            <div className="space-y-6">
              <FAQItem title="Why do I have a Digitalbookshelfcare.com charge on my bank statement?" icon={<FiHeart />}>
                If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of Digitalbookshelfcare.com, but a client of a site that has delegated the management of its customer service.
              </FAQItem>

              <FAQItem title="What are the services offered by Digitalbookshelfcare.com?" icon={<FiFlag />}>
                Digitalbookshelfcare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.
              </FAQItem>

              <FAQItem title="What kind of subscription do you need for after-sales service?" icon={<FiSearch />}>
                Digitalbookshelfcare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.
              </FAQItem>

              <FAQItem title="I do not remember signing up to a Digitalbookshelfcare.com subscription." icon={<FiShare2 />}>
                You have not signed up to a Digitalbookshelfcare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.
              </FAQItem>

              <FAQItem title="How to find the offer to which I subscribed?" icon={<FiLink />}>
                Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.
              </FAQItem>

              <FAQItem title="I forgot the email address used when subscribing. What can I do?" icon={<FiUser />}>
                If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.
              </FAQItem>

              <FAQItem title="Who can I contact if I have a question?" icon={<FiMessageCircle />}>
                Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.
              </FAQItem>

              <FAQItem title="How can I cancel my subscription?" icon={<FiUsers />}>
                Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.
              </FAQItem>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

